import type { Chapter } from "@/mocks/readerPages";

interface Props {
  open: boolean;
  onClose: () => void;
  night: boolean;
  chapters: Chapter[];
  currentChapter: number;
  onSelect: (id: number) => void;
  comicTitle: string;
}

export default function ChapterDrawer({
  open,
  onClose,
  night,
  chapters,
  currentChapter,
  onSelect,
  comicTitle,
}: Props) {
  return (
    <>
      <div
        className={`fixed inset-0 z-50 bg-foreground-950/50 backdrop-blur-sm transition-opacity duration-300 ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
        onClick={onClose}
      ></div>

      <aside
        className={`fixed right-0 top-0 z-50 flex h-full w-full max-w-sm flex-col border-l transition-transform duration-300 ${
          night ? "border-background-800 bg-background-950" : "border-background-200 bg-background-50"
        } ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        <div
          className={`flex items-center justify-between border-b px-5 py-4 ${
            night ? "border-background-800" : "border-background-200"
          }`}
        >
          <div>
            <h2 className="text-sm font-bold text-foreground-950">章节目录</h2>
            <p className={`mt-0.5 text-xs ${night ? "text-foreground-400" : "text-foreground-500"}`}>
              {comicTitle}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭目录"
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              night ? "hover:bg-background-900" : "hover:bg-background-100"
            }`}
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-3 py-3">
          <div className="flex flex-col gap-1">
            {chapters.map((ch) => {
              const active = ch.id === currentChapter;
              return (
                <button
                  key={ch.id}
                  type="button"
                  onClick={() => onSelect(ch.id)}
                  className={`flex items-center justify-between gap-2 rounded-md px-3 py-2.5 text-left text-sm transition-colors ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : night
                      ? "text-foreground-200 hover:bg-background-900"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  <span className="truncate">{ch.title}</span>
                  <span
                    className={`flex shrink-0 items-center gap-1 text-xs ${
                      active ? "text-background-50/80" : night ? "text-foreground-500" : "text-foreground-400"
                    }`}
                  >
                    {ch.isNew && <i className="ri-sparkling-2-fill text-accent-500"></i>}
                    {ch.pages}页
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </aside>
    </>
  );
}